exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#introduction-popup{position:fixed;z-index:101;padding-top:100px;left:0;top:0;right:0;bottom:0;overflow:auto;background-color:rgba(0,0,0,.7)}#introduction-popup .introduction-popup__content{background-color:#fefefe;margin:auto;padding:20px;width:80%;border-radius:15px;position:relative}#introduction-popup .introduction-popup__title{text-align:center;font-size:38px;width:calc(100% + 40px);margin-top:-20px;margin-left:-20px;padding:20px 0;background:rgba(0,0,0,.1)}#introduction-popup .introduction-popup__close{color:#aaa;position:absolute;font-size:36px;top:20px;right:20px;font-weight:700}#introduction-popup .introduction-popup__close:focus,#introduction-popup .introduction-popup__close:hover{color:#000;text-decoration:none;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/popups/dashboard/introduction-popup/introduction-popup.scss
// module id = 1493
// module chunks = 0